whenReady('jQuery', function() {

  console.log("jquery loaded")
  
  function updateFreeGifts(dataPack) {
      dataPack = parseInt(dataPack, 10);
  
      $('.free-gift__main_wrap .gift--item').each(function () {
          var $item = $(this);
          var threshold = parseInt($item.data('threshold'), 10);
          var $img = $item.find('img');
          var $text = $item.find('p');
  
          if (threshold <= dataPack) {
              // UNLOCKED STATE
              $item.addClass('unlocked');
              $img.attr('src', $item.data('img-unlocked'));
              $text.html($item.data('unlocked-text'));
          } else {
              // LOCKED STATE
              $item.removeClass('unlocked');
              $img.attr('src', $item.data('img-locked'));
              $text.html($item.data('original-label'));
          }
      });
  }
  
  // On pack change
  $('.pdp-recharge-option input').on('change', function () {
      const variantId = $(this).data('variant-id');
      updateDynamicPrice(variantId);
      updateFreeGifts($(this).data('pack'));
  });
  
  // On page load
  $(document).ready(function () {
      var selectedPack = $('.pdp-recharge-option input:checked').data('pack');
      if (selectedPack !== undefined) {
          updateFreeGifts(selectedPack);
      }
  });
  $('.pdp-recharge-option.one-time.one-time-off').on('click', function(){
      $(this).removeClass('one-time-off').addClass('one-time-active');
  });
  $('.vertical_col_view .subscription-purchase .recharge-subscription-opt').on('click', function(){
      $('.pdp-recharge-option__selling-plan-info .pdp-recharge-option-item').addClass('pdp-recharge-option-item--active');
  });
  
  
  const sellingPlanData = JSON.parse(
    document.getElementById('variant-selling-plans').textContent
  );
  
  function updateDynamicPrice(variantId) {
    const variantData = sellingPlanData[variantId];
    if (!variantData) return;
  
    /* ======================
       One-time purchase price
       ====================== */
    $('.var_price').html(variantData.regular_price || '');
  
    if (variantData.compare_at_price) {
      $('.var_price_comp')
        .html(variantData.compare_at_price)
        .show();
    } else {
      $('.var_price_comp').hide();
    }
  
    /* ======================
       Subscription price
       ====================== */
    const sellingPlans = variantData.selling_plans || {};
    const firstSellingPlanId = Object.keys(sellingPlans)[0];
  
    if (!firstSellingPlanId) return;
  
    const sp = sellingPlans[firstSellingPlanId];
  
    // actual subscription price
    $('.sub-price_actual').html(sp.price || '');
  
    // 🔥 EXACT requirement
    const comparePrice =
      variantData.compare_at_price || variantData.regular_price;
  
    $('.sub-price_compare')
      .html(comparePrice)
      .show();
  }
  
  /* ======================
     Initial load (default)
     ====================== */
  $(document).ready(function () {
    const defaultVariantId = $('.pdp-recharge-option input:checked')
      .data('variant-id');
  
    if (defaultVariantId) {
      updateDynamicPrice(defaultVariantId);
    }
  });

})  
